import { render, staticRenderFns } from "./xlsIntroduce.vue?vue&type=template&id=6240622c&scoped=true&"
import script from "./xlsIntroduce.vue?vue&type=script&lang=js&"
export * from "./xlsIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./xlsIntroduce.vue?vue&type=style&index=0&id=6240622c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6240622c",
  null
  
)

export default component.exports